import { observer } from 'mobx-react';

import Button from '@/common/components/Button/Button';
import Heading from '@/common/components/Heading/Heading';
import browserHistory from '@/common/services/history';

import styles from './ForwardNotification.module.css';

export interface ForwardNotificationProps {
  title: string;
  buttonText?: string;
  url: string;
}

// browserHistory.push is used here because notifications are shown outside react-router context
function ForwardNotification(props: ForwardNotificationProps) {
  const { title, buttonText = 'Open', url } = props;

  return (
    <div className={styles.container}>
      <Heading appearance="h4" className={styles.title}>
        {title}
      </Heading>

      <Button
        color="accent"
        size="s"
        className={styles.navigationButton}
        aria-label={buttonText}
        onClick={() => browserHistory.push(url)}
      >
        {buttonText}
      </Button>
    </div>
  );
}

export default observer(ForwardNotification);
